// This service now interacts with the global GTP (gtag.js) defined in index.html
// This ensures better SEO detection and avoids double-tracking.

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
        dataLayer: any[];
    }
}

export const analytics = {
    isInitialized: true, // It's initialized in index.html

    init: () => {
        // Already handled in index.html manually for SEO speed
        console.log('[Analytics] Using global script');
    },

    sendPageView: (path: string, title?: string) => {
        if (typeof window.gtag !== 'function') return;

        window.gtag('event', 'page_view', {
            page_path: path,
            page_title: title
        });

        if (import.meta.env.DEV) {
            console.log(`[Analytics] Page View: ${path}`);
        }
    },

    sendEvent: (category: string, action: string, label?: string, value?: number) => {
        if (typeof window.gtag !== 'function') return;

        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value
        });

        if (import.meta.env.DEV) {
            console.log(`[Analytics] Event: ${category} - ${action}`);
        }
    }
};
